import { render, staticRenderFns } from "./CertificateCheck.vue?vue&type=template&id=1beb4c19&"
import script from "./CertificateCheck.vue?vue&type=script&lang=js&"
export * from "./CertificateCheck.vue?vue&type=script&lang=js&"
import style0 from "./CertificateCheck.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports